import { displayYear } from '../../utils/Format/Format';

export const calendarYearTotalReturnsCardUtil = (gqlResult) => {
    if (!gqlResult) return null;

    const {
        mutualFund: {
            tenYearHistoricalReturns,
            correspondingFund,
            name,
            inceptionDate,
            iClass,
            standardPerformanceReturns
        }
    } = gqlResult;

    const { quarterlyAnnualReturns } = standardPerformanceReturns || {};
    const { fundPerformance } = quarterlyAnnualReturns || {};
    const {
        oneYearReturnTacked,
        threeYearReturnTacked,
        fiveYearReturnTacked,
        tenYearReturnTacked,
        sinceInceptionReturnTacked
    } =
        fundPerformance || {};

    const { inceptionDate: correspondingInceptionDate } =
        correspondingFund || {};

    const { tenYearHistoricalReturns: correspondingTenYearReturns = [] } =
        correspondingFund || {};

    // @TODO: can switch to this once syntax support is merged into master
    // const correspondingInceptionDate = correspondingFund?.inceptionDate;
    // const correspondingTenYearReturns =
    //     correspondingFund?.tenYearHistoricalReturns || [];

    const hasTacked =
        iClass &&
        [
            oneYearReturnTacked,
            threeYearReturnTacked,
            fiveYearReturnTacked,
            tenYearReturnTacked,
            sinceInceptionReturnTacked
        ].includes(true) &&
        !!correspondingFund;

    let chosenTenYearReturns;

    if (hasTacked) {
        // if IClass version has some data points, use them but "stitch in" the missing data from
        // the corresponding investor version
        if (tenYearHistoricalReturns && tenYearHistoricalReturns.length) {
            chosenTenYearReturns = tenYearHistoricalReturns.map(
                (dataPoint, index) =>
                    dataPoint && dataPoint.fundReturn
                        ? dataPoint
                        : correspondingTenYearReturns[index]
            );
        } else {
            // if IClass version has zero data points just use the corresponding investor version's
            // data in its entirety
            chosenTenYearReturns = correspondingTenYearReturns;
        }
    } else {
        chosenTenYearReturns = tenYearHistoricalReturns;
    }

    const chartData = chosenTenYearReturns.map((ele) => ({
        label: displayYear(ele.asOfDate),
        headers: [name],
        data: [ele.fundReturn / 100]
    }));

    return {
        chartData,
        inceptionDate: hasTacked ? correspondingInceptionDate : inceptionDate,
        hasTacked
    };
};
